export const setImpersonation = () => sessionStorage.setItem('impersonation', 'true');
export const removeImpersonation = () => sessionStorage.removeItem('impersonation');
export const getImpersonation = () => sessionStorage.getItem('impersonation');
